import { envConfig } from '../../../env';
import { Post } from '@/service/request/server';

const baseUrl = envConfig.formalServer + '/cotton';

function createApi(url, insertName, deleteName, updateName, queryName) {
    return {
        insert(data) {
            return Post(`${url}/${insertName}`, data);
        },
        deleteData(data) {
            return Post(`${url}/${deleteName}`, data);
        },
        update(data) {
            return Post(`${url}/${updateName}`, data);
        },
        query(data) {
            return Post(`${url}/${queryName}`, data);
        }
    };
}

export const customerContactApi = createApi(
    baseUrl + '/admin/customer/contact',
    'insertCustomerContact',
    'deleteCustomerContact',
    'updateCustomerContact',
    'queryCustomerContact'
);

export const customerQaGroupApi = createApi(
    baseUrl + '/admin/customer/qa/group',
    'insertCustomerQaGroup',
    'deleteCustomerQaGroup',
    'updateCustomerQaGroup',
    'queryCustomerQaGroup'
);

export const customerQaApi = createApi(
    baseUrl + '/admin/customer/qa',
    'insertCustomerQa',
    'deleteCustomerQa',
    'updateCustomerQa',
    'queryCustomerQa'
);
